import { render, staticRenderFns } from "./Apuntate.vue?vue&type=template&id=6965ecc2&scoped=true&"
import script from "./Apuntate.vue?vue&type=script&lang=js&"
export * from "./Apuntate.vue?vue&type=script&lang=js&"
import style0 from "./Apuntate.vue?vue&type=style&index=0&id=6965ecc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6965ecc2",
  null
  
)

export default component.exports